import { motion } from "framer-motion";

export const SectionLabel = ({ num, label, id }) => (
  <div data-testid={`section-label-${id}`} className="flex items-center gap-4 mb-12">
    <span className="font-mono text-sm text-[#2563eb]">{num}</span>
    <span className="h-px w-8 bg-[#2563eb]" />
    <span className="font-mono text-[12px] tracking-[0.3em] uppercase text-[#8b95a5]">{label}</span>
  </div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
